module.exports = __webpack_public_path__ + "c08f861631a0605cc813f18619781e59.MP3";